import React from 'react';
import {
  Box,
  Heading,
  Badge,
  Text,
  HStack,
  VStack,
  Stat,
  StatLabel,
  StatNumber,
  StatHelpText,
  Button,
  Icon,
  Avatar,
  useColorModeValue,
} from '@chakra-ui/react';
import { FiEdit2, FiTrash2, FiMic, FiMessageCircle, FiUsers, FiSettings } from 'react-icons/fi';
import { BsBuilding } from 'react-icons/bs';

const formatDate = (dateStr) => {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  return d.toLocaleDateString();
};

const ClubCard = ({ club, onEdit, onDelete }) => {
  const cardBg = useColorModeValue('gray.900', 'gray.700');
  const borderColor = useColorModeValue('gray.700', 'gray.600');
  return (
    <Box bg={cardBg} borderRadius="lg" borderWidth={1} borderColor={borderColor} p={5} boxShadow="md" minW="300px">
      <HStack justify="space-between" align="start" mb={2}>
        <HStack spacing={3} align="center">
          <Avatar bg="blue.500" icon={<BsBuilding fontSize="1.5rem" />} size="md" />
          <VStack align="start" spacing={0}>
            <Heading size="md" color="white">{club.name}</Heading>
            <Text fontSize="xs" color="gray.400">ID: {club._id || club.id}</Text>
          </VStack>
        </HStack>
        <Badge colorScheme={club.status === 'active' ? 'green' : 'gray'} fontSize="0.8em" px={2} py={0.5} borderRadius="md">
          {club.status?.toUpperCase()}
        </Badge>
      </HStack>
      <Text mt={1} mb={3} color="gray.200" fontSize="sm">{club.description}</Text>
      <HStack spacing={8} mt={2} mb={2} align="start">
        <Stat>
          <StatLabel color="gray.400"><Icon as={FiMic} color="orange.400" mr={1}/> Voice Agents</StatLabel>
          <StatNumber color="white" fontSize="lg">{Array.isArray(club.voiceBots) ? club.voiceBots.length : 0}</StatNumber>
          <StatHelpText color="gray.400">{Array.isArray(club.voiceBots) && club.voiceBots.length > 0 ? 'Configured' : 'Not configured'}</StatHelpText>
        </Stat>
        <Stat>
          <StatLabel color="gray.400"><Icon as={FiMessageCircle} color="green.400" mr={1}/> Chat Agents</StatLabel>
          <StatNumber color="white" fontSize="lg">{Array.isArray(club.chatBots) ? club.chatBots.length : 0}</StatNumber>
          <StatHelpText color="gray.400">{Array.isArray(club.chatBots) ? `${club.chatBots.length} projects` : '0 projects'}</StatHelpText>
        </Stat>
      </HStack>
      <HStack mt={3} spacing={4} color="gray.300" fontSize="sm">
        <HStack spacing={1}><Icon as={FiUsers} /> <Text>{club.memberCount || 0} Members</Text></HStack>
        <HStack spacing={1}><Icon as={FiSettings} /> <Text>Created: {formatDate(club.createdAt)}</Text></HStack>
        {Array.isArray(club.voiceBots) && club.voiceBots.length > 0 && <Badge colorScheme="green" variant="subtle">VOICE</Badge>}
        {Array.isArray(club.chatBots) && club.chatBots.length > 0 && <Badge colorScheme="blue" variant="subtle">CHAT</Badge>}
      </HStack>
      <HStack mt={4} spacing={2}>
        <Button leftIcon={<FiEdit2 />} size="sm" variant="outline" colorScheme="whiteAlpha" onClick={() => onEdit(club)}>
          Edit
        </Button>
        <Button leftIcon={<FiTrash2 />} size="sm" colorScheme="red" variant="outline" onClick={() => onDelete(club)}>
          Delete
        </Button>
      </HStack>
    </Box>
  );
};

export default ClubCard; 